<template>
<div>
    <div class="card" :key="setupServiceKey">
        <div class="card-body p-5">
            <div class="accordion accordion-clean" role="tablist">
                <b-card no-body>
                    <b-card-header header-tag="header" class="border-bottom" role="tab">
                        <a class="card-title" block v-b-toggle.accAddService>{{$t('header.add')}}{{$t('subMenu.salon_menu_service')}} 
                            <span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-chevron-up fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-chevron-down fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </b-card-header>
                    <b-collapse id="accAddService" accordion="serviceAccordian" role="tabpanel" class="pb-5">
                        <b-card-body class="pt-3">
                            <form @submit.prevent="addService">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.title')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-text"></i>
                                            </span>
                                        </div>
                                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">{{$t('label.price')}}</label>
                                            <div class="input-group bg-white shadow-inset-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text bg-transparent border-right-0">
                                                        <i class="fas fa-dollar-sign"></i>
                                                    </span>
                                                </div>
                                                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.price')" @keypress="isNumber($event)" v-model="price" required="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">{{$t('label.base_price')}}</label>
                                            <div class="input-group bg-white shadow-inset-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text bg-transparent border-right-0">
                                                        <i class="fas fa-dollar-sign"></i>
                                                    </span>
                                                </div>
                                                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.base_price')" @keypress="isNumber($event)" v-model="basePrice" required="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">{{$t('label.category')}}</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <label class="input-group-text" for="serviceCategory">
                                                        <i class="fas fa-tag"></i>
                                                    </label>
                                                </div>
                                                <select class="custom-select" id="serviceCategory" v-model="selectedCategory">
                                                    <option v-for="c in category" :key="c.id" :value="c.id">{{c.text}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">{{$t('label.duration')}}</label>
                                            <div class="input-group bg-white shadow-inset-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text bg-transparent border-right-0">
                                                        <i class="fas fa-clock"></i>
                                                    </span>
                                                </div>
                                                <vue-timepicker class="form-control bg-transparent" :format="'H hr mm Min'" :hide-disabled-hours="true" :hour-range="hourRange" :minute-range="minRange" :minute-interval="15" v-model="duration" @change="setTimePicker"></vue-timepicker>
                                            </div>
                                            <div id="err" class="error-validation"></div>
                                        </div>
                                    </div>
                                </div> 
                                <div class="text-left pt-3 mt-3 mb-3">
                                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.add')}}</button>
                                </div>
                            </form>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                 <b-card no-body>
                    <b-card-header header-tag="header" class="border-bottom" role="tab">
                        <a class="card-title" block v-b-toggle.accListService>{{$t('header.list_of', {'item': $t('subMenu.salon_menu_service')})}}
                            <span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-chevron-up fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-chevron-down fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </b-card-header>
                    <b-collapse id="accListService" accordion="serviceAccordian" role="tabpanel" visible="visible">
                        <b-card-body class="card-body pt-3">
                            <div class="dataTables_wrapper dt-bootstrap4">
                                <div class="row">
                                    <div class="col-sm-12 overflow-auto">
                                         <b-table v-if="serviceItems.length != 0" small striped hover bordered :fields="fields" :items="serviceItems" responsive>
                                            <template #cell(index)="data">
                                                {{ data.index + 1 }}
                                            </template>
                                            <template #cell(price)="data">
                                                {{parseFloat(data.item.price).toFixed(2)}}
                                            </template>
                                            <template #cell(category)="data">
                                                {{getCategory(data.item.category)}}
                                            </template>
                                            <template #cell(online)="data">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" :id="'cbx_' + data.item.itemID" v-model="hasOnline[data.item.itemID]">
                                                    <label class="custom-control-label" :for="'cbx_' + data.item.itemID"></label>
                                                </div>
                                            </template>
                                         </b-table>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                 </b-card>
            </div>
            <div class="text-left border-top pt-5">
                <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mr-3" @click="returnPreviousStep">{{$t('button_link.prev')}}</button>
                <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="submitService">{{$t('button_link.next')}}</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import VueTimepicker from 'vue2-timepicker'
import cst from './../../../../assets/js/dashboard/table-header'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {convertToMin, isNumber} from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'setupService',
    components:{
        VueTimepicker
    },
    data(){
        return{
            step: 3,
            setupServiceKey: 0,
            type: "service",
            hourRange: [], minRange: [],
            categoryList: "",
            category: [],
            title: "", price: 0, basePrice: 0, selectedCategory: 0, duration:"",
            serviceItems: [], 
        }
    },
    computed:{
        hasOnline(){
            var ret = {};
            for(var i=0; i<this.serviceItems.length; i++){
                ret[this.serviceItems[i].itemID] = this.serviceItems[i].showOnline == "1" ? true : false;
            }
            return ret;
        },
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true},
                { key: "online", label: this.$i18n.t('table.header.online'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
            ]
        },
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        setTimePicker(e){
           if(e.data.H != "0"){
               this.minRange = []
               for(var i=0; i<4; i++){
                   this.minRange.push(i*15)
               }
           }else{
                this.minRange = []
                for(var j=1; j<4; j++){
                    this.minRange.push(j*15)
                }
           }
           document.getElementById('err').innerHTML = null;
        },
        getCategory(id){
            var text = "";
            for(var i=0; i<this.category.length; i++){
                if(id == this.category[i].id){
                    text = this.$i18n.t('label.category') + ' ' + (id+1) + ' - ' +  this.category[i].text;
                    break;
                }
            }
            return text;
        },
        closeModal(isError){
            if(!isError){
                this.getServiceItem();
                this.setupServiceKey += 1;
            }
            this.$parent.$parent.isModalShow = false
        },
        addService(){
            if(this.duration.H == "0" && this.duration.mm == "00"){
                document.getElementById('err').innerHTML = this.$msg.ERR_DURATION;
            }else{
                var duration = this.duration.H + " hr " + this.duration.mm + " Min"
                var data = {
                    type: this.type,
                    title: this.title,
                    category: this.selectedCategory,    
                    price: this.price,
                    duration: convertToMin(duration),
                    showOnline: "1"
                }

                let $vm = this
                $vm.$axios({
                    method: 'post', 
                    url: $vm.$api.MENU_ITEM,
                    baseURL: $vm.$axios.defaults.baseURL, 
                    headers: {token: $vm.$session.get('token')},
                    data: data,
                })
                .then((response) => {
                    if(response.status == 200){
                        var retData = response.data;
                        var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.add')
                        $vm.$parent.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if(errData.error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();  
                    }else{
                        var message = errData.error == "invalid base price" ? $vm.$i18n.t('message.error.invalid_base_price') : $vm.$i18n.t('message.error.system_error')
                        $vm.$parent.$parent.setModal($vm, true, true, message);
                    }
                })
            }
            
        },
        returnPreviousStep(){
            this.$emit('returnPreviousStep', this.step);
        },
        submitService(){
            var results = [];
            for(var i=0; i<this.serviceItems.length; i++){
                var isOnline = this.hasOnline[this.serviceItems[i].itemID] ? "1" : "";
                this.serviceItems[i].showOnline = isOnline;
                results.push(this.serviceItems[i]);
            }
            var data = {items: results};

            let $vm = this
            const url = this.$api.MENU_ITEM + this.$api.UPDATE
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    this.$emit('submitService', this.step);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.duplicate_service'))
                }
            })
        },
        getServiceItem(){
            let $vm = this;
            let QUERY_STRING = "?type=service"
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.serviceItems = response.data.items;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        $vm.categoryList = JSON.parse($vm.$store.state.category);
        for(var i=0; i<$vm.categoryList.service.length; i++){
            $vm.category.push({id: i, text: $vm.categoryList.service[i]});
        }

        $vm.duration = {
        "H": "0",
        "mm": "30",
        }

        for(var k=1; k<4; k++){
            $vm.minRange.push(k*15);
        }

        for(var j=0; j<10; j++){
            $vm.hourRange.push(j);
        }
        $vm.getServiceItem()
    }
}
</script>
<style scoped>
.show{
    display: block;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>